<template>

    <section class="">
        

      <div class="relative grid items-center ">
        <nuxt-img width="1600" height="854" format="webp" src="/assets/images/rainforest.jpg"
            alt="bacgrkound section image" class="absolute object-cover w-full h-full" loading="lazy"
            sizes="xs:360px sm:640px md:768px lg:1024px xl:1600px" />

        <div class="relative z-[9] md:py-20 py-10">

            <div class="grid items-center max-w-screen-xl grid-cols-12 px-4 mx-auto gap-x-6 lg:gap-x-12 gap-y-8">
                <div class="col-span-12 md:col-span-6 sm-max:order-2">
                    <nuxt-img width="579" height="647" format="webp" src="/assets/images/rainforest-2.jpg"
                        alt="section image" class="mx-auto" loading="lazy"
                        sizes="xs:360px sm:640px md:768px lg:1024px xl:579px" />
                </div>

                <div class="max-w-sm col-span-12 mx-auto space-y-4 md:col-span-6">
                    <h4 class="font-bold text-center text-white h2">
                        “Drink Coffee And Save The Planet”
                    </h4>

                    <p class="font-normal text-center text-white textp font-ww-regular lg:px-6">
                        A portion of the profits are donated to Rainforest Trust and Project Alianza for conservation of
                        the wildlife and to build schools in local areas for the farmers children.
                    </p>

                    <div class="pt-8 md:pt-16">
                        <nuxt-img width="240" height="170" format="webp" src="/assets/images/rainfores-logo.png"
                        alt="section image" class="m-auto lg:full lg:w-42 w-36" loading="lazy"
                        sizes="xs:200px sm:200px md:200px lg:200px xl:200px" />
                        
                    </div>
                </div>
            </div>

        </div>
      </div>

    </section>


</template>

<script setup>

defineBuilderComponent({
    friendlyName: 'BgTexImage',
    ignored: true
})

</script>